import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'mpResumen',
  data() {
    return {
      msg: '-',
      loading: false,
      tbv: null,
      f_c: {
        desde: this.date_rest(this.currentdate(), -30),
        hasta: this.currentdate(),
      }
    }
  },
  computed: {
    reporte: function () {
      return (
        "/billeteras/MP/resumen/dia?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },
  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: ['excelHtml5'],
    });
    $('.box').boxWidget();
  },
  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/billeteras/MP/resumen/dia', this.f_c)
        .then(response => {
          response.data.data.forEach(row => {
            row[3] = this.num_to_many(row[3]);
            row[4] = this.num_to_many(row[4]);
            row[5] = this.num_to_many(row[5]);
            row[6] = this.num_to_many(row[6]);
            row[7] = this.num_to_many(row[7]);
            row[8] = this.num_to_many(row[8]);
            row[9] = this.num_to_many(row[9]);
            row[10] = this.num_to_many(row[10]);
            row[11] = this.num_to_many(row[11]);
            this.tbv.row.add(row);
          });
          this.tbv.draw();
          this.loading = false;
        });
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/reportes/mpCobrosPagosDia/index.js